import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class MundialTeam extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "pot", Model.attribute('pot'));
    _defineProperty(this, "points", Model.attribute('points'));
    _defineProperty(this, "voteCount", Model.attribute('voteCount'));
    _defineProperty(this, "voters", Model.attribute('voters'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/MundialTeam', MundialTeam);